module.exports = __webpack_public_path__ + "static/media/fresh-factory-img11.5bdddfdc.png";